import { MdOutlineCalendarToday, MdSentimentDissatisfied, MdSentimentNeutral, MdSentimentSatisfiedAlt } from "react-icons/md";
import styles from './reviewsList.module.css';


const FEELINGS = {
    good: { label: 'Boa', Icon: MdSentimentSatisfiedAlt, className: styles.good },
    medium: { label: 'Média', Icon: MdSentimentNeutral, className: styles.medium },
    bad: { label: 'Ruim', Icon: MdSentimentDissatisfied, className: styles.bad },
};

const APP_LABELS = { app: 'SofChef', cmv: 'CMV' };


// INICIAIS DO NOME PARA O AVATAR (ATÉ 2 LETRAS)
const getInitials = (name) => {
    const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);

    if (parts.length == 0) return '?';

    return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
};


export default function ReviewsList({ reviews }) {
    return (
        <div className={styles.reviewsContainer}>
            {reviews.map((item, index) => {
                const name = item.name?.trim() || 'Usuário sem nome';

                const date = new Date(item.created_at);
                const created_at = isNaN(date) ? '-' : date.toLocaleDateString('pt-BR');

                const feeling = FEELINGS[item.feeling] ?? FEELINGS.bad;
                const FeelingIcon = feeling.Icon;

                const app = APP_LABELS[item.app] ?? item.app ?? '-';

                return (
                    <div className={`${styles.reviewComponent} ${feeling.className}`} key={item.id ?? index}>
                        <div className={styles.labelRow}>
                            <div className={`${styles.avatar} ${feeling.className}`}>{getInitials(name)}</div>

                            <div className={styles.reviewUser}>
                                <p className={styles.reviewTitle}>{name}</p>

                                <p className={styles.reviewMeta}>
                                    <MdOutlineCalendarToday size={13} /> {created_at}
                                </p>
                            </div>

                            <div className={`${styles.feelingContainer} ${feeling.className}`}>
                                <FeelingIcon size={16} /> {feeling.label}
                            </div>
                        </div>

                        <p className={styles.reviewText}>{item.description || 'Sem descrição.'}</p>

                        <div className={styles.footerRow}>
                            <span className={styles.appTag}>{app}</span>
                        </div>
                    </div>
                );
            })}
        </div>
    )
}
